/**
 * @param {string} referer
 * @returns {*}
 */
function isDirectTraffic (referer) {
  if (typeof document === 'undefined' || !referer) return

  const hostPattern = new RegExp(`^(https?://)?(www.)?${window.location.hostname}`)
  return referer?.match(hostPattern)
}

module.exports = { isDirectTraffic }
